import { AxiosRequestConfig, AxiosResponse } from "axios";
import apiGuard from "../../../context-controller-mod/context-serv/global-provider/api-shell/api-gaurd";

const ApiPut = <T = unknown>(
  url: string,
  data?: FormData | Record<string, unknown>,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  return apiGuard.put<T>(url, data, config);
};

export default ApiPut;